/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */

export type LayoutDocumentoResponseModelo = typeof LayoutDocumentoResponseModelo[keyof typeof LayoutDocumentoResponseModelo];


export const LayoutDocumentoResponseModelo = {
  CLASSICO: 'CLASSICO',
  FAIXA: 'FAIXA',
  MOLDURA: 'MOLDURA',
  MINIMALISTA: 'MINIMALISTA',
  COMPACTO: 'COMPACTO',
} as const;
